// ---------------------------------------------------------------------------
// Reply rate — the one ratio the campaign screen shows
//
// It replaced a "Response" card that was `totalReplied / totalSent`, where
// `totalSent` counts emails only: "—" on every LinkedIn campaign, and replies
// from both channels over the emails alone on a cross-channel one. Markus asked
// what set it apart from "Replied"; the honest answer was nothing.
//
// Both numbers come from the server, computed from the leads
// (`detailLeadCounts`): replied = `repliedAt` set, contacted = reached on any
// channel. Nobody contacted yet is "—", not "0%": no rate has been measured.
// ---------------------------------------------------------------------------

export function replyRate(campaign: { totalReplied?: number; totalContacted?: number; totalSent?: number }): string {
  const contacted = campaign.totalContacted ?? 0;
  if (contacted <= 0) return '—';
  return `${Math.round(((campaign.totalReplied ?? 0) / contacted) * 100)}%`;
}
